import { render, staticRenderFns } from "./AInspectionPlanDetailStaff.vue?vue&type=template&id=55cd0104&scoped=true"
import script from "./AInspectionPlanDetailStaff.vue?vue&type=script&lang=js"
export * from "./AInspectionPlanDetailStaff.vue?vue&type=script&lang=js"
import style0 from "./AInspectionPlanDetailStaff.vue?vue&type=style&index=0&id=55cd0104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd0104",
  null
  
)

export default component.exports